import formatDate from '@anm/helpers/date/formatDate';
import { FC } from 'react';

import { CancelBlockWrapper } from './Wrapper';

export type CancelBlockProps = { date: number };

const CancelBlock: FC<CancelBlockProps> = ({ date }) => (
  <CancelBlockWrapper>
    <span>Cancels on </span>
    <span>
      {formatDate(date, {
        isHours: false,
        monthFormat: 'MMMM'
      })}
    </span>
  </CancelBlockWrapper>
);

export default CancelBlock;
